import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksPl = () => {
    return <HowStartpageWorks languageCode="pl" />
}

export default HowStartpageWorksPl
